export default __webpack_public_path__ + "static/media/adsform-sec3-bg.609ce667.jpg";